module.exports = __webpack_public_path__ + "4857fac0aa04486767e1f54161a7dd8f.svg";